// extracted by mini-css-extract-plugin
export var styleInput = "styles-module--styleInput--8vDea";
export var styleSubmit = "styles-module--styleSubmit--1Zw5f";